import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Typography,
  Box,
  Tooltip,
  IconButton,
  InputBase,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  CardMedia,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseDriversManage } from "./UseDriversManage";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import DeleteRow from "../../components/DeleteRow";
import {
  rsGotoLast,
  rsProgress,
  rsParentChilds,
  rsActiveMenu,
} from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import { useSnackbar } from "notistack";

export default function DriversManage() {
  const { enqueueSnackbar } = useSnackbar();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [parentID, setParentID] = useRecoilState(rsParentChilds);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const {
    getDriversList,
    DeleteDriver,
    AddDriver,
    EditDriver,
    getDriverByMobile,
  } = UseDriversManage();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [userMobile, setUserMobile] = useState();
  const [userDetails, setUserDetails] = useState();
  const [userId, setUserId] = useState({ id: "" });
  const [openDialog, setOpenDialog] = useState({
    show: false,
    model: undefined,
  });
  const [driverRes, setDriverRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getDriversList(
      myPc,
      search,
      (drivers) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(drivers.pageCondition.totalPage);
          return;
        }
        setDriverRes(drivers);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    setOpen(true);
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "driver",
      headerName: "نام راننده",
      width: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.driver}
          </Typography>
        );
      },
    },
    {
      field: "phone",
      headerName: "موبایل",
      width: 180,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "active",
      headerName: "وضعیت",
      width: 80,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.active ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 110,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {cellValues.row.active ? (
              <Tooltip title="غیرفعال">
                <span>
                  <IconButton
                    onClick={() => {
                      let send = {
                        id: cellValues.row.id,
                        active: false,
                      };
                      setOpenDialog({
                        show: true,
                        model: send,
                        name: "غیرفعال",
                      });
                    }}
                  >
                    <CloseIcon fontSize="small" sx={{ color: "red" }} />
                  </IconButton>
                </span>
              </Tooltip>
            ) : (
              <Tooltip title="فعال">
                <span>
                  <IconButton
                    onClick={() => {
                      let send = {
                        id: cellValues.row.id,
                        active: true,
                      };
                      setOpenDialog({
                        show: true,
                        model: send,
                        name: "فعال",
                      });
                    }}
                  >
                    <VisibilityIcon fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
            )}
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.driver,
                    id: cellValues.row.id,
                    model: { id: cellValues.row.id },
                  });
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              fullWidth
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "لجستیک",
        childs: [{ name: msActiveMenu.pageTitle, url: "/drivermanage" }],
      }}
    >
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={openDialog.show}
        onClose={() => setOpenDialog({ ...openDialog, show: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          آیا از {openDialog.name} کردن راننده اطمینان دارید ؟
        </DialogTitle>
        <DialogActions>
          <Button
            sx={{ color: "#565656 !important" }}
            onClick={() =>
              EditDriver(openDialog.model, (callback) => {
                setOpenDialog({ ...openDialog, show: false });
                getDriversList(
                  myPc,
                  search,
                  (drivers) => {
                    if (msGotoLast) {
                      setMsGotoLast(false);
                      goToLastPage(drivers.pageCondition.totalPage);
                      return;
                    }
                    setDriverRes(drivers);
                  },
                  true
                );
              })
            }
          >
            بله
          </Button>
          <Button
            color="secondary"
            onClick={() => setOpenDialog({ ...openDialog, show: false })}
          >
            خیر
          </Button>
        </DialogActions>
      </Dialog>
      {driverRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={driverRes.pageCondition.pageCount}
          rows={driverRes.driver}
          paginationMode="server"
          page={driverRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={
            driverRes?.pageCondition.totalItemCount
              ? driverRes.pageCondition.totalItemCount
              : 0
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              newFunc: newFunc,
              isLtr: true,
              rowCount: driverRes?.pageCondition.totalItemCount
                ? driverRes.pageCondition.totalItemCount
                : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"راننده"}
        callback={() => {
          setProgress(true);
          DeleteDriver(deleteState.model, () => {
            refresh();
          });
        }}
      ></DeleteRow>
      <Dialog
        open={open}
        maxWidth="xs"
        fullWidth
        sx={{
          "& .MuiPaper-root ": {
            height: "30",
          },
        }}
        onClose={() => {
          setUserMobile();
          setUserDetails();
          setOpen(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <TextField
              size="small"
              autoFocus
              id="outlined-basic"
              value={userMobile ? userMobile : ""}
              label="شماره کاربر را وارد کنید "
              fullWidth
              variant="outlined"
              onChange={(event) => {
                if (event.target.value) {
                  setUserMobile(event.target.value);
                } else {
                  setUserMobile();
                  setUserDetails();
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setProgress(true);
                  getDriverByMobile(userMobile, (callback) => {
                    if (callback) {
                      setUserDetails(callback);
                    } else {
                      setUserMobile();
                      setUserDetails();
                    }
                  });
                }
              }}
            />
            <Button
              size="small"
              variant="contained"
              disabled={userMobile ? false : true}
              onClick={() => {
                setProgress(true);
                getDriverByMobile(userMobile, (callback) => {
                  if (callback) {
                    setUserDetails(callback);
                  } else {
                    setUserMobile();
                    setUserDetails();
                  }
                });
              }}
            >
              یافتن
            </Button>
          </Box>
          {userDetails ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2 }}>
              <Typography variant="subtitle2">نام کاربر : </Typography>
              <Typography color="secondary" variant="subtitle1">
                {userDetails.driver}
              </Typography>
            </Box>
          ) : (
            ""
          )}
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            m: 2,
            mt: 0,
          }}
        >
          <Button
            size="small"
            variant="contained"
            color="secondary"
            // disabled={userDetails?.id ? false : true}
            onClick={() => {
              setUserDetails();
              setUserMobile();
            }}
          >
            جدید
          </Button>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Button
              size="small"
              variant="contained"
              disabled={userDetails?.id ? false : true}
              onClick={() => {
                setProgress(true);
                let UserId = { id: userDetails.id };
                AddDriver(UserId, () => {
                  getDriversList(
                    myPc,
                    search,
                    (drivers) => {
                      if (msGotoLast) {
                        setMsGotoLast(false);
                        goToLastPage(drivers.pageCondition.totalPage);
                        return;
                      }
                      setDriverRes(drivers);
                    },
                    true
                  );
                  setUserDetails();
                  setUserMobile();
                  setOpen(false);
                });
              }}
            >
              اضافه کردن
            </Button>
            <Button
              size="small"
              variant="outlined"
              color="secondary"
              onClick={() => {
                setUserMobile();
                setUserDetails();
                setOpen(false);
              }}
            >
              انصراف
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </Detail>
  );
}
